import { useEffect } from 'react';

const COLORES = ['#E62530', '#1E3F94', '#D99114', '#1E7D4F', '#7FC4EC'];
const PIEZAS = 90;
const DURACION_MS = 6000;

/**
 * Confeti de celebración, portado de la demo.
 *
 * Se pinta con nodos sueltos en el body y no con estado de React porque son 90 elementos
 * puramente decorativos: meterlos al árbol obligaría a re-renderizar por nada. Lo que sí
 * importa es la limpieza — el `useEffect` devuelve la función que los borra, para que
 * salir de la pantalla antes de tiempo no deje nodos colgados.
 */
export function Confeti() {
  useEffect(() => {
    const nodos: HTMLDivElement[] = [];

    for (let i = 0; i < PIEZAS; i++) {
      const pieza = document.createElement('div');
      const lado = 6 + Math.random() * 8;
      pieza.className = 'confeti';
      pieza.style.cssText = [
        'position:fixed',
        'top:-20px',
        'z-index:200',
        'pointer-events:none',
        `left:${Math.random() * 100}vw`,
        `width:${lado}px`,
        `height:${lado * 1.4}px`,
        `background:${COLORES[i % COLORES.length]}`,
        `animation:caer ${2.2 + Math.random() * 2.4}s linear ${Math.random() * 0.9}s forwards`,
      ].join(';');
      document.body.appendChild(pieza);
      nodos.push(pieza);
    }

    const reloj = setTimeout(() => nodos.forEach((n) => n.remove()), DURACION_MS);

    return () => {
      clearTimeout(reloj);
      nodos.forEach((n) => n.remove());
    };
  }, []);

  return null;
}
